import styled from '@emotion/styled'
import { css } from '@emotion/react'

const Container = styled.section`
  & {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-flow: row nowrap;
    padding: 0;
  }

  .symbol-container {
    margin: 0 10px 0 0;
    height: 90px;
    width: 60px;
    flex: 0 0 80px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }

  .text-container {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-flow: column nowrap;
    font-size: var(--fs-300);
    font-weight: 300;
    color: ${({ theme }) => theme.colors.secondary[900]};
    line-height: normal;
  }

  .text-container > h1 {
    font-size: var(--fs-500);
    font-weight: 500;
    margin: 0 0 1px 0;
  }

  ${({ theme }) =>
    css(
      theme.size.mq({
        '&': {
          flexFlow: [
            'column nowrap',
            'column nowrap',
            'column nowrap',
            'row nowrap',
          ],
          alignItems: ['center', 'center', 'flex-start', 'flex-start'],
        },
        '.text-container': {
          alignItems: ['center', 'center', 'flex-start', 'flex-start'],
          textAlign: ['center', 'center', 'left'],
        },
      }),
    ).styles}
`

export default Container
